<template>
    <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
            <v-btn icon small color="blue-grey" v-on="on">
                <v-icon>mdi-camera</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <h4 class="title blue-grey--text accent-4">그룹 이미지 바꾸기</h4>
            </v-card-title>
            <v-card-text>
                <v-file-input v-model="files" label="선택" prepend-icon="mdi-camera"></v-file-input>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue-grey accent-4" :loading="loading" class="white--text mb-3" @click="upload">Post it!</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
  
</template>

<script>
import db from '@/fb'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firebase-storage'

export default {
    name: 'ProfileImage',
    props: [ 'groupId', 'group' ],
    data: () => ({
        dialog: false,
        loading: false,
        value: 10,
        files: []
    }),
    methods: {
        upload(){
            this.loading = true;

            // get file
            const file = this.files

            // get the extended file name
            const index = file.name.indexOf('.')
            const extension = file.name.slice(index).toLowerCase();

            // create a storage ref
            let storageRef = firebase.storage().ref(this.groupId + '/' + 'group-images/' + Date.now() + extension)

            // upload file
            var metadata = {
                contentType: 'image/jpeg'
            };
            let uploadTask = storageRef.put(file, metadata)            

            // update progressive bar
            // Listen for state changes, errors, and completion of the upload.
            uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
                (snapshot) => {
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    // console.log('Upload is ' + progress + '% done');
                    switch (snapshot.state) {
                    case firebase.storage.TaskState.PAUSED: // or 'paused'
                        // console.log('Upload is paused');
                        break;
                    case firebase.storage.TaskState.RUNNING: // or 'running'
                        // console.log('Upload is running');
                        break;
                    }
                }, (error) => {

                    // A full list of error codes is available at
                    // https://firebase.google.com/docs/storage/web/handle-errors
                    switch (error.code) {
                        case 'storage/unauthorized':
                        // User doesn't have permission to access the object
                        break;

                        case 'storage/canceled':
                        // User canceled the upload
                        break;

                        case 'storage/unknown':
                        // Unknown error occurred, inspect error.serverResponse
                        break;
                }
                }, () => {
                    
                    // Upload completed successfully, now we can get the download URL
                    uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
                        // console.log('File available at', downloadURL);
                        db.collection("groups").doc(this.groupId).update({
                            imgURL: downloadURL
                        }).then(() => {
                            this.group.imgURL = downloadURL
                            this.dialog = false;
                            this.loading = false;
                            // location.reload()
                        })
                    })
                });
        }
    }
};
</script>